import { render } from "./ModalInfoAward.vue?vue&type=template&id=0cfc60fb&scoped=true"
import script from "./ModalInfoAward.vue?vue&type=script&lang=js"
export * from "./ModalInfoAward.vue?vue&type=script&lang=js"

import "./ModalInfoAward.vue?vue&type=style&index=0&id=0cfc60fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfc60fb"]])

export default __exports__